"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const calculation_1 = require("@wurzel/uzb-calculation/dist/calculation");
const util_1 = require("./util");
function getVariablesPackingMaterialDelivery(move, configuration) {
    var _a;
    const effectivePackingMaterial = calculation_1.getPackingMaterial(move, configuration);
    const packingMaterials = configuration.packingMaterials;
    const packmaterialVorab = Object.fromEntries(packingMaterials.map((p, i) => [`vorabName${i + 1}`, p.name]));
    const mengeVorab = Object.fromEntries(packingMaterials
        .map((p) => effectivePackingMaterial.find((ep) => ep.packingMaterial.id === p.id))
        .map((p, i) => [
        `vorabMenge${i + 1}`,
        p != null && p.inAdvance > 0
            ? `${p.inAdvance} ${util_1.getUnit(p.packingMaterial.unit)}`
            : "",
    ]));
    return {
        beladestelle: util_1.getAddressVariables((_a = move.loadingAddresses[0]) !== null && _a !== void 0 ? _a : move.customer),
        datum: move.loadingDates
            .map((d) => util_1.formatDate(d.date))
            .filter((d) => !!d)
            .join(" / "),
        ...packmaterialVorab,
        ...mengeVorab,
    };
}
exports.default = getVariablesPackingMaterialDelivery;
//# sourceMappingURL=packingMaterialDelivery.js.map